import React from "react";
import { Menu, Layout } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import menuItems from "./menuItems";

const { Sider } = Layout;

export default function SideBar() {
  let location = useLocation();
  const pathName = location.pathname;
  const handleChangeKey = (pathName) => {
    const key = pathName.split("/");
    return key.length === 2 ? "/setting" : `/${key[1]}/${key[2]}`;
  };

  return (
    <Sider style={{ flex: 1, borderRight: "1px solid #f0f0f0" }}>
      <Menu
        expandIcon={<RightOutlined />}
        theme="light"
        selectedKeys={[handleChangeKey(pathName)]}
        mode="inline"
        items={menuItems}
      />
    </Sider>
  );
}
